import { render, staticRenderFns } from "./DosyaFiltrelemeCard.vue?vue&type=template&id=68d6b822&scoped=true"
import script from "./DosyaFiltrelemeCard.vue?vue&type=script&lang=ts"
export * from "./DosyaFiltrelemeCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d6b822",
  null
  
)

export default component.exports